<template>
  <modal :height="650" :width="300" name="modalParameters">
    <div class="modalStyle">
      <h4 class="card-title" v-if="!this.device.params">Add Parameter</h4>
      <h4 class="card-title" v-if="this.device.params">Edit Parameter</h4>
      <form id="formParams">
        <div class="form-group" >
          <div class="col-md-12">
            <label> Temperature 1 &nbsp</label>
            <input type="checkbox"
                   label="Temperature"
                   name="temperature"
                   v-model="device.temperature1">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Temperature 2 &nbsp</label>
            <input type="checkbox"
                   label="Temperature2"
                   name="temperature2"
                   v-model="device.temperature2">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Temperature 3 &nbsp</label>
            <input type="checkbox"
                   label="Temperature3"
                   name="temperature3"
                   v-model="device.temperature3">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Humidity &nbsp</label>
            <input type="checkbox"
                   label="Humidity"
                   name="humidity"
                   v-model="device.humidity">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Pressure &nbsp</label>
            <input type="checkbox"
                   label="Pressure"
                   name="pressure"
                   v-model="device.pressure">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Light &nbsp</label>
            <input type="checkbox"
                   label="Light"
                   name="light"
                   placeholder="Light"
                   v-model="device.light">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Wind 1 &nbsp</label>
            <input type="checkbox"
                   label="WindSpeed1"
                   name="windSpeed1"
                   placeholder="WindSpeed1"
                   v-model="device.windSpeed1">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Wind 2 &nbsp</label>
            <input type="checkbox"
                   label="WindSpeed2"
                   name="windSpeed2"
                   v-model="device.windSpeed2">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Battery &nbsp</label>
            <input type="checkbox"
                   label="Battery"
                   name="battery"
                   v-model="device.battery">
          </div>
        </div>
        <div class="form-group" >
          <div class="col-md-12">
            <label> Panel &nbsp</label>
            <input type="checkbox"
                   label="Panel"
                   name="panel"
                   v-model="device.panel">
          </div>
        </div>
        <div class="buttonModal">
          <button class="btn btn-info btn-fill float-right" v-if="!this.device.edit">
            Add
          </button>
          <button class="btn btn-info btn-fill float-right" v-if="this.device.edit">
            Save
          </button>
        </div>
      </form>
    </div>
  </modal>

</template>

<script>
    export default {
        name: 'l-modal-device-params-edit',
        props: {
            isAdmin: false
        },
        data() {
            return {
                device: {
                    id: '',
                    timestamp: '',
                    temperature1: '',
                    temperature2: '',
                    temperature3: '',
                    humidity: '',
                    pressure: '',
                    light: '',
                    windSpeed1: '',
                    windSpeed2: '',
                    battery: '',
                    panel: '',
                    edit: false
                },


            }
        },
        methods: {

            // addParams() {
            //     this.device.id = '';
            //     this.device.timestamp = '';
            //     this.device.temperature1 = '';
            //     this.device.temperature2 = '';
            //     this.device.temperature3 = '';
            //     this.device.humidity = '';
            //     this.device.pressure = '';
            //     this.device.wind1 = '';
            //     this.device.wind2 = '';
            //     this.device.battery = '';
            //     this.device.panel = '';
            //     this.device.edit = false;
            //
            //     this.showAddModal();
            // },
            // editParams(item) {
            //     this.$http.get('device/' + item.id)
            //         .then(result => {
            //             this.device = result.data;
            //             this.device.edit = true;
            //
            //             this.showAddModal();
            //         }, error => {
            //             console.error(error);
            //         });
            // },
            editParams(item) {
                this.$modal.show('modalParameters');
            },
            showAddModal() {
                this.$modal.show('modalParameter');
            },
            closeAddModal() {
                this.$modal.hide('modalParameter');
            },
        }
    }
</script>

<style scoped>

</style>
